import { useEffect, useState, useRef } from 'react';
import { ContactPage, ManageAccounts, Cancel, Check } from '@mui/icons-material';
import UpdateReferralRequestModal from './components/UpdateReferralRequestModal';

// material-ui
import {
    Box,
    Button,
    Grid,
    Typography,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    Modal,
    TextField,
    FormControl,
    Select,
    MenuItem,
    Autocomplete,
    CircularProgress
} from '@mui/material';

import { deepPurple } from '@mui/material/colors';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import { gridSpacing } from 'app/constant';

import { useSelector } from 'react-redux';
import { selectCurrentToken } from 'features/auth/authSlice';
import dayjs from 'dayjs';
import { axiosInstance } from 'utils/axios';
import { toast } from 'react-toastify';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import * as XLSX from 'xlsx';

import useFetchData from 'hooks/useFetchData';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: 600,
    minWidth: '800px',
    // width: '90%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    padding: '20px',
    borderRadius: '10px'
};

const columns = [
    { id: 'id', label: 'ID', minWidth: 30 },
    // { id: 'referrerCustomerID', label: 'Referrer Customer ID', minWidth: 120 },
    { id: 'clientName', label: 'Client Name', minWidth: 170 },
    { id: 'customerLoginUserName', label: 'Login User Name', minWidth: 170 },
    // { id: 'refereeCustomerID', label: 'Referee Customer ID', minWidth: 170 },
    { id: 'dateLabel', label: 'Date Label', minWidth: 190, type: 'date' },
    { id: 'amount', label: 'Amount', minWidth: 170 },
    { id: 'estimatedProcessingFees', label: 'Processing Fees', minWidth: 170 },
    { id: 'finalAmount', label: 'Final Amount', minWidth: 120 },
    // { id: 'processingFees', label: 'Actual Processing Fees', minWidth: 170 },
    {
        id: 'statusName',
        label: 'Status',
        minWidth: 170
    },
    {
        id: 'bankVendorName',
        label: 'Bank Vendor Name',
        minWidth: 170
    },
    {
        id: 'bankAccountNumber',
        label: 'Bank Account Number',
        minWidth: 170
    },
    {
        id: 'bankAccountHolderName',
        label: 'Bank Account Holder Name',
        minWidth: 170
    },
    {
        id: 'thirdPartyName',
        label: 'Third Party',
        minWidth: 170
    },
    { id: 'createdDate', label: 'Created Date', minWidth: 190, type: 'date' },
    { id: 'userName', label: 'User Name', minWidth: 170 }
];

const ReferralRequests = () => {
    const { data: thirdpartyList } = useFetchData('/ThirdParty');
    const token = useSelector(selectCurrentToken);
    const [referralDetails, setReferralDetails] = useState([]);
    const [filterReferralRequestsFrom, setFilerReferralRequestsFrom] = useState(dayjs().subtract(1, 'days'));
    const [filterReferralRequestsTo, setFilerReferralRequestsTo] = useState(dayjs());
    const [refereeName, setRefereeeName] = useState('');
    const [referrerName, setReferrerName] = useState('');
    const [customerNameOptions, setCustomerNameOptions] = useState([]);
    const [isAllowFilterUserName, setIsAllowFilterUserName] = useState();
    const [filterBtnDisabled, setFilterBtnDisabled] = useState(false);
    const [refereeLoginUserName, setRefereeeLoginUserName] = useState('');
    const [referrerLoginUserName, setReferrerLoginUserName] = useState('');

    const [loginUserNames, setLoginUserNames] = useState([]);

    const warningAlert = (message) => {
        toast.warning(message, {
            position: toast.POSITION.TOP_CENTER
        });
    };

    const errorAlert = (message) => {
        toast.error(message, {
            position: toast.POSITION.TOP_CENTER
        });
    };
    const successAlert = (message) => {
        toast.success(message, {
            position: toast.POSITION.TOP_CENTER
        });
    };

    const [page, setPage] = useState(0);
    useEffect(() => {
        const savedPage = localStorage.getItem('currentPage');
        if (savedPage !== null) {
            setPage(parseInt(savedPage, 10));
        } else {
            setPage(0);
        }
    }, []);
    localStorage.setItem('currentPage', 0);

    //fetch Referral Details start
    const [fetchReferralRequestsLoading, setFetchReferralRequestsLoading] = useState(false);
    const fetchReferralRequests = async () => {
        setFilterBtnDisabled(true);
        setTimeout(() => {
            setFilterBtnDisabled(false);
        }, 3000);

        if (!filterReferralRequestsFrom.isValid() || !filterReferralRequestsTo.isValid()) {
            warningAlert('Please fill/All all required fields.');
            return;
        }
        let referralURL = `/ReferralDetailsRequest/All?dateLabelFrom=${filterReferralRequestsFrom.format(
            'YYYY-MM-DD'
        )}&dateLabelTo=${filterReferralRequestsTo.format('YYYY-MM-DD')}`;

        if (refereeLoginUserName !== '') {
            referralURL += `&customerLoginUserName=${refereeLoginUserName}`;
        }

        if (filterStatusName !== '') {
            referralURL += `&statusID=${parseInt(filterStatusName)}`;
        }
        setFetchReferralRequestsLoading(true);
        try {
            const res = await axiosInstance.get(referralURL, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (res.status === 200) {
                setReferralDetails(res.data);
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        } finally {
            setFetchReferralRequestsLoading(false);
        }
    };
    //fetch Referral Details end

    const [exportDataListLoading, setExportDataListLoading] = useState(false);
    function convertDataForSheet(data) {
        if (!data || data.length === 0) {
            warningAlert('There is no data to export');
            throw new Error('Data array is empty or undefined.');
        }

        const headers = Object.keys(data[0]);
        const dataArray = [headers];

        data.forEach((item) => {
            const row = headers.map((key) => item[key]);
            dataArray.push(row);
        });

        return XLSX.utils.aoa_to_sheet(dataArray);
    }
    const exportDataAsXlsx = async () => {
        setFilterBtnDisabled(true);
        setTimeout(() => {
            setFilterBtnDisabled(false);
        }, 3000);
        setExportDataListLoading(true);
        if (!filterReferralRequestsFrom.isValid() || !filterReferralRequestsTo.isValid()) {
            warningAlert('Please fill/All all required fields.');
            return;
        }
        let referralURL = `/ReferralDetailsRequest/All?dateLabelFrom=${filterReferralRequestsFrom.format(
            'YYYY-MM-DD'
        )}&dateLabelTo=${filterReferralRequestsTo.format('YYYY-MM-DD')}`;

        if (refereeLoginUserName !== '') {
            referralURL += `&customerLoginUserName=${refereeLoginUserName}`;
        }

        if (filterStatusName !== '') {
            referralURL += `&statusID=${parseInt(filterStatusName)}`;
        }

        try {
            const res = await axiosInstance.get(referralURL, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (res.status === 200) {
                const fileName = `ReferralRequests_${dayjs().format('MM-DD-YYYY')}`;
                const workbook = XLSX.utils.book_new();
                const worksheet = convertDataForSheet(res.data);
                // Adjust column widths
                const headers = Object.keys(res.data[0]);
                const colWidths = headers.map((header) => ({ wch: header.length + 2 }));

                worksheet['!cols'] = colWidths;

                XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
                XLSX.writeFile(workbook, `${fileName}.xlsx`);
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        } finally {
            setExportDataListLoading(false);
        }
    };

    const fetchIsAllowFilterUserName = async () => {
        try {
            const res = await axiosInstance.get(`/isAllowFilterUserName`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            if (res.status === 200) {
                setIsAllowFilterUserName(res.data);
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        }
    };

    const [referralStatusList, setReferralStatusList] = useState([]);
    const fetchReferralStatus = async () => {
        try {
            const res = await axiosInstance.get('/Referral/Status/All', {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (res.status === 200) {
                setReferralStatusList(res.data);
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        }
    };

    const [customerLoginUserNameOptions, setCustomerLoginUserNameOptions] = useState([]);
    const fetchCustomerLoginUserNamesOptions = async () => {
        try {
            const res = await axiosInstance.get('/Customer/LoginUserNames', {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (res.status === 200) {
                setCustomerLoginUserNameOptions(res.data);
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                await Promise.all([
                    fetchReferralRequests(),
                    // fetchLoginUserNames(),
                    // fetchThirdParty(),
                    fetchIsAllowFilterUserName(),
                    fetchReferralStatus(),
                    //fetchThirdPartyDropdownList(),
                    fetchCustomerLoginUserNamesOptions()
                ]);
            } catch (error) {
                console.log(error);
            }
        };

        fetchData();
    }, []);

    //Referral table start
    function StickyHeadTable() {
        const [rowsPerPage, setRowsPerPage] = useState(() => {
            const storedRowsPerPage = localStorage.getItem('rowsPerPage');
            return storedRowsPerPage ? parseInt(storedRowsPerPage, 10) : 100;
        });

        const handleChangePage = (event, newPage) => {
            setPage(newPage);
        };

        const handleChangeRowsPerPage = (event) => {
            const newRowsPerPage = +event.target.value;
            setRowsPerPage(newRowsPerPage);
            setPage(0);
            localStorage.setItem('rowsPerPage', newRowsPerPage.toString());
        };

        //approve request start
        const approveReferralRequest = async (row) => {
            try {
                const res = await axiosInstance.post(
                    `/ApproveReferralDetailsRequest`,
                    {
                        id: parseInt(row.id)
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                );
                if (res.status === 200) {
                    successAlert('Request Approved Successfully.');
                    // fetchReferralRequests();
                    // update the row status
                    const updatedRow = { ...row };
                    updatedRow['statusName'] = 'Paid';
                    updatedRow['statusID'] = 2;
                    setReferralDetails(referralDetails.map((item) => (item.id === row.id ? updatedRow : item)));
                } else {
                    errorAlert('Something went wrong.');
                }
            } catch (error) {
                console.log(error);
            }
        };
        //approve request end

        useEffect(() => {
            localStorage.setItem('rowsPerPage', rowsPerPage.toString());
        }, [rowsPerPage]);

        return (
            <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                <TableContainer sx={{ maxHeight: 440 }}>
                    <Table stickyHeader aria-label="sticky table">
                        <TableHead>
                            <TableRow>
                                {columns.map((column) => (
                                    <TableCell key={column.id} align={column.align} style={{ minWidth: column.minWidth }}>
                                        {column.label}
                                    </TableCell>
                                ))}
                                <TableCell></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {referralDetails.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                                return (
                                    <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                                        {columns.map((column) => {
                                            let value = row[column.id];
                                            if (column.type && column.type === 'date') {
                                                if (value) {
                                                    const timeString12hr = new Date(
                                                        '1970-01-01T' + value.split('T')[1] + 'Z'
                                                    ).toLocaleTimeString('en-US', {
                                                        timeZone: 'UTC',
                                                        hour12: true,
                                                        hour: 'numeric',
                                                        minute: 'numeric',
                                                        second: 'numeric'
                                                    });
                                                    value = `${value.split('T')[0]} ${timeString12hr}`;
                                                }
                                            }
                                            return (
                                                <TableCell key={column.id} align={column.align}>
                                                    {column.format && typeof value === 'number' ? column.format(value) : value}
                                                </TableCell>
                                            );
                                        })}
                                        <TableCell>
                                            <Box sx={{ display: row.statusID == 2 ? 'none' : 'block', alignItems: 'center', gap: '10px' }}>
                                                {/* <UpdateReferralRequestModal referralRequest={row} thirdParty={thirdpartyList} fetchReferralRequests={fetchReferralRequests} /> */}
                                                <Button
                                                    onClick={() => approveReferralRequest(row)}
                                                    sx={{
                                                        border: 'none',
                                                        backgroundColor: 'transparent',
                                                        width: 'fit-content',
                                                        height: 'fit-content',
                                                        color: deepPurple[500],
                                                        display: 'block'
                                                    }}
                                                >
                                                    <Check />
                                                </Button>
                                            </Box>
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[10, 25, 100]}
                    component="div"
                    count={referralDetails.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Paper>
        );
    }
    //Referral table end

    const [usersList, setUsersList] = useState([]);
    const [filterReferralUsername, setFilterReferralUsername] = useState('');
    const [filterStatusName, setFilterStatusName] = useState('');
    //fetch customer names for autocomplete start
    const fetchUserNamesOption = async () => {
        try {
            const res = await axiosInstance.get('/Usernames', {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            if (res.status === 200) {
                setUsersList(res.data);
            }
        } catch (error) {
            console.log(error);
        }
    };
    //fetch customer names for autocomplete end

    useEffect(() => {
        const fetchData = async () => {
            try {
                await Promise.all([fetchUserNamesOption()]);
            } catch (error) {
                console.log(error);
            }
        };

        fetchData();
    }, []);

    return (
        <Grid container item xs={12}>
            <Box sx={{ width: '100%', display: 'flex', justifyContent: 'end', alignItems: 'end' }}>{/* <BatchApprove /> */}</Box>

            <Grid item container xs={12} spacing={gridSpacing} sx={{ marginBottom: '10px', overflowY: 'auto' }}>
                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            <span style={{ color: 'red' }}>*</span>From :
                        </Typography>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                value={filterReferralRequestsFrom}
                                slotProps={{
                                    textField: {
                                        error: false
                                    }
                                }}
                                onChange={(newValue) => setFilerReferralRequestsFrom(newValue)}
                            />
                        </LocalizationProvider>
                    </Box>
                </Grid>
                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            <span style={{ color: 'red' }}>*</span>To :
                        </Typography>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                value={filterReferralRequestsTo}
                                slotProps={{
                                    textField: {
                                        error: false
                                    }
                                }}
                                onChange={(newValue) => setFilerReferralRequestsTo(newValue)}
                            />
                        </LocalizationProvider>
                    </Box>
                </Grid>

                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            Login User Name :
                        </Typography>
                        <Autocomplete
                            freeSolo
                            value={refereeLoginUserName}
                            onChange={(event, newValue) => {
                                setRefereeeLoginUserName(newValue);
                            }}
                            inputValue={refereeLoginUserName}
                            onInputChange={(event, newInputValue) => {
                                setRefereeeLoginUserName(newInputValue);
                            }}
                            id="controllable-states-demo"
                            options={customerLoginUserNameOptions}
                            sx={{ width: 170 }}
                            renderInput={(params) => <TextField {...params} />}
                            disableClearable
                        />
                    </Box>
                </Grid>

                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap',
                                color: isAllowFilterUserName ? '' : 'grey'
                            }}
                        >
                            Status :
                        </Typography>

                        <Select
                            displayEmpty
                            value={filterStatusName}
                            onChange={(e) => setFilterStatusName(e.target.value)}
                            // sx={{width:"100%"}}
                        >
                            <MenuItem sx={{ width: '100%' }} value="">
                                Select Status
                            </MenuItem>
                            {referralStatusList.map((item, index) => (
                                <MenuItem sx={{ width: '100%' }} value={item.id} key={index}>
                                    {item.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </Box>
                </Grid>

                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'end',
                        alignItems: 'center',
                        gap: '15px',
                        width: '50%',
                        marginLeft: 'auto'
                    }}
                >
                    <Button
                        variant="contained"
                        sx={{
                            display: 'block',
                            mx: 'auto',
                            width: '150px',
                            backgroundColor: deepPurple[500],
                            marginTop: '20px',
                            marginBottom: '20px'
                        }}
                        onClick={() => fetchReferralRequests()}
                        disabled={filterBtnDisabled}
                    >
                        Filter
                    </Button>
                    <Button
                        variant="contained"
                        sx={{
                            display: 'block',
                            mx: 'auto',
                            width: '150px',
                            backgroundColor: deepPurple[500],
                            marginTop: '20px',
                            marginBottom: '20px'
                        }}
                        onClick={() => exportDataAsXlsx()}
                        disabled={filterBtnDisabled}
                    >
                        Export Data
                    </Button>
                </Box>
            </Grid>
            <Box sx={{ width: '100%', minHeight: '200px' }}>
                {fetchReferralRequestsLoading ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                        <CircularProgress />
                    </Box>
                ) : (
                    <StickyHeadTable />
                )}
            </Box>
        </Grid>
    );
};

export default ReferralRequests;
